import { useContext } from 'react';
import { AuthContext, type AuthState } from '@/lib/authContext';

export function useAuth(): AuthState {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error('useAuth must be used inside AuthProvider');
  return ctx;
}

/**
 * Role check for rendering decisions.
 *
 * This gates UI only. The server decides what a caller may actually see, and
 * masks fields before they leave (02 §4.1) — hiding a button here is a
 * usability choice, never a security control.
 */
export function useHasRole(...roles: string[]): boolean {
  const { identity } = useAuth();
  if (!identity) return false;
  return roles.some((r) => identity.roles?.includes(r));
}
